import React from "react";
import ProfilePic from "../resource/profile_pic.png";
import { Badge } from "react-bootstrap";
import Moment from "react-moment";
import 'moment/locale/zh-hk';
import { webSiteUrl } from "../utility";
import "../css/ChatUser.css";

const ChatUser = (props) => {
  const {
    listItemId,
    chatRoomData,
    index,
    selectUser,
    currentUser,
    lastUpdateSeconds,
    selectedChatUser,
  } = props;

  let lastMessageContent = null;
  let lastMessageTime = null;

  if (chatRoomData.lastMessage?.sentBy == currentUser.uid) {
    lastMessageContent = `${chatRoomData.lastMessage?.messageText == "{file}" ? "相片" : chatRoomData.lastMessage?.messageText
      }`;
  } else {
    lastMessageContent = `${chatRoomData.lastMessage?.messageText == "{file}" ? "相片" : chatRoomData.lastMessage?.messageText
      }`;
  }

  const d = new Date(lastUpdateSeconds * 1000);
  lastMessageTime = d.toLocaleTimeString(undefined, {});

  let unreadBadge = null;
  if (
    chatRoomData.lastMessage.sentTo == currentUser.uid &&
    chatRoomData.lastMessage.unReadCount > 0
  ) {
    unreadBadge = (
      <Badge pill bg="danger" className="unReadCounter">
        {chatRoomData.lastMessage.unReadCount}
      </Badge>
    );
  }

  let offerContent = null;
  if (currentUser.uid == chatRoomData.createdUser) {
    /* I buy this item */
    if (chatRoomData.lastOffer?.offeredStatus == "offered") {
      offerContent = (
        <>
          <Badge pill bg="primary" text="light">
            已出價
          </Badge>{" "}
          HK$ {chatRoomData.lastOffer?.offeredPrice}
        </>
      );
    } else if (chatRoomData.lastOffer?.offeredStatus == "cancelled") {
      offerContent = (
        <>
          <Badge pill bg="secondary">
            已取消
          </Badge>{" "}
          HK$ {chatRoomData.lastOffer?.offeredPrice}
        </>
      );
    } else if (chatRoomData.lastOffer?.offeredStatus == "accepted") {
      let theBadge = null;
      if (chatRoomData.reviewStatus?.createdUserReviewStatus) {
        theBadge = (
          <>
            <Badge pill bg="success">
              已評價
            </Badge>{" "}
            成交 HK$ {chatRoomData.lastOffer?.offeredPrice}
          </>
        );
      } else {
        theBadge = (
          <>
            <Badge pill bg="warning" text="dark">
              已成交
            </Badge>{" "}
            HK$ {chatRoomData.lastOffer?.offeredPrice}
          </>
        );
      }
      offerContent = theBadge;
    } else if (chatRoomData.lastOffer?.offeredStatus == "rejected") {
      offerContent = (
        <>
          <Badge pill bg="danger">
            已拒絕
          </Badge>{" "}
          HK$ {chatRoomData.lastOffer?.offeredPrice}
        </>
      );
    }
  } else {
    /* i own this item */
    if (chatRoomData.lastOffer?.offeredStatus == "offered") {
      offerContent = (
        <>
          <Badge pill bg="primary" text="light">
            出價
          </Badge>{" "}
          HK$ {chatRoomData.lastOffer?.offeredPrice}
        </>
      );
    } else if (chatRoomData.lastOffer?.offeredStatus == "cancelled") {
      offerContent = (
        <>
          <Badge pill bg="secondary">
            已取消
          </Badge>{" "}
          HK$ {chatRoomData.lastOffer?.offeredPrice}
        </>
      );
    } else if (chatRoomData.lastOffer?.offeredStatus == "accepted") {
      let theBadge = null;
      if (chatRoomData.reviewStatus?.itemOwnerReviewStatus) {
        theBadge = (
          <>
            <Badge pill bg="success">
              已評價
            </Badge>{" "}
            成交 HK$ {chatRoomData.lastOffer?.offeredPrice}
          </>
        );
      } else {
        theBadge = (
          <>
            <Badge pill bg="warning" text="dark">
              已成交
            </Badge>{" "}
            HK$ {chatRoomData.lastOffer?.offeredPrice}
          </>
        );
      }
      offerContent = theBadge;
    } else if (chatRoomData.lastOffer?.offeredStatus == "rejected") {
      offerContent = (
        <>
          <Badge pill bg="danger">
            已拒絕
          </Badge>{" "}
          HK$ {chatRoomData.lastOffer?.offeredPrice}
        </>
      );
    }
  }

  const theChatUsername = chatRoomData.sentUser?.suspended ? <><s class="suspended">{chatRoomData.sentUser?.username}</s><br></br><span class="suspendedTag">已被封鎖</span></> : chatRoomData.sentUser?.username;

  return (
    <div
      className={selectedChatUser ? "user_wrapper selected" : "user_wrapper"}
      onClick={() => selectUser(chatRoomData.id)}
    >
      <div className="user_info">
        <img
          src={
            chatRoomData.sentUser?.avatar
              ? webSiteUrl + chatRoomData.sentUser.avatar
              : ProfilePic
          }
          alt="avatar"
          className="avatar"
        />
        <div className="user_detail">
          <div className="user_name">{theChatUsername}</div>
          <div className="item"><span dangerouslySetInnerHTML={{ __html: chatRoomData.itemInfo?.itemName}} /></div>
          <div className="last_message">{lastMessageContent}</div>
          <div className="offer">{offerContent}</div>
          <div className="user_misc">
            <div className="user_message_date">
              {/* {lastMessageTime} */}
              <Moment fromNow>{chatRoomData.lastUpdatedTime.toDate().toString()}</Moment>
            </div>
            {unreadBadge}
          </div>
        </div>
        {/* <div
          className={`user_status ${chatRoomData.isOnline ? "online" : "offline"}`}
        ></div> */}
      </div>
    </div>
  );
};

export default ChatUser;
